import React from 'react';
import { ArrowRight, Check, Clock, Lock, RotateCcw } from 'lucide-react';

/**
 * Intro screen for the hormone assessment.
 * If `onResume` is provided, the user has saved progress in sessionStorage
 * and we show a primary "Resume" CTA + a "Start over" link.
 * Otherwise, we show the standard "Begin Assessment" CTA.
 */
const IntakeIntro = ({ onBegin, onResume = null, onStartOver = null }) => {
  const isResuming = !!onResume;

  return (
    <div className="assessment-intro">
      <div className="assessment-intro-content">
        <div className="intro-card-centered">
          {isResuming && (
            <div className="intro-resume-banner" data-testid="intake-resume-banner">
              <RotateCcw size={16} strokeWidth={1.75} />
              <span>You have an assessment in progress.</span>
            </div>
          )}

          <div className="intro-time-badge" data-testid="intake-intro-time-badge">
            <Clock size={14} strokeWidth={1.75} />
            <span>About 2 minutes</span>
          </div>

          <h1 className="intro-card-title">Clinician-Guided Hormone Evaluation</h1>

          <div className="intro-card-body">
            <p>
              This structured assessment analyzes key symptom patterns used in medical hormone
              evaluations. Your responses are securely reviewed by a licensed provider before
              any recommendations are made.
            </p>
            <p>
              If appropriate, you will be invited to schedule a 1:1 eligibility consultation
              to review your results and discuss personalized treatment options.
            </p>
          </div>

          <div className="intro-trust-bullets">
            <span className="intro-trust-bullet">
              <Check size={16} />
              Reviewed by a licensed clinician
            </span>
            <span className="intro-trust-bullet">
              <Lock size={16} />
              HIPAA-secure and confidential
            </span>
            <span className="intro-trust-bullet">
              <Check size={16} />
              Personalized, evidence-based care
            </span>
          </div>

          {isResuming ? (
            <>
              <button
                className="btn-assessment-primary"
                onClick={onResume}
                data-testid="resume-assessment-btn"
              >
                Resume Assessment
                <ArrowRight size={18} />
              </button>
              <button
                type="button"
                className="intro-start-over-link"
                onClick={onStartOver}
                data-testid="start-over-btn"
              >
                Start over
              </button>
            </>
          ) : (
            <button
              className="btn-assessment-primary"
              onClick={onBegin}
              data-testid="begin-assessment-btn"
            >
              Begin Assessment
              <ArrowRight size={18} />
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default IntakeIntro;
